
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.7462 4.29541C13.2139 4.29541 11.9796 5.53322 11.9796 7.0698C11.9796 7.28322 12.0647 7.49663 12.1073 7.71005L7.38292 10.1003C6.87218 9.46005 6.14862 9.03322 5.25482 9.03322C3.72258 9.03322 2.48828 10.271 2.48828 11.8076C2.48828 13.3442 3.72258 14.582 5.25482 14.582C6.10606 14.582 6.87218 14.1552 7.38292 13.5149L12.1073 15.9052C12.0647 16.1186 11.9796 16.332 11.9796 16.5454C11.9796 18.082 13.2139 19.3198 14.7462 19.3198C16.2784 19.3198 17.5127 18.082 17.5127 16.5454C17.5127 15.0088 16.2784 13.771 14.7462 13.771C13.8949 13.771 13.1288 14.1979 12.6181 14.8381L7.89366 12.4479C7.93622 12.2344 8.02135 12.021 8.02135 11.8076C8.02135 11.5942 7.93622 11.3808 7.89366 11.1674L12.6181 8.77712C13.1288 9.41737 13.8524 9.8442 14.7462 9.8442C16.2784 9.8442 17.5127 8.60639 17.5127 7.0698C17.5127 5.53322 16.2784 4.29541 14.7462 4.29541ZM14.7462 5.44785C15.64 5.44785 16.321 6.13078 16.321 7.02712C16.321 7.92346 15.64 8.60639 14.7462 8.60639C13.8524 8.60639 13.1714 7.92346 13.1714 7.02712C13.1714 6.13078 13.8524 5.44785 14.7462 5.44785ZM5.25482 10.2283C6.14862 10.2283 6.82961 10.9113 6.82961 11.8076C6.82961 12.704 6.14862 13.3869 5.25482 13.3869C4.36101 13.3869 3.68001 12.704 3.68001 11.8076C3.68001 10.9113 4.36101 10.2283 5.25482 10.2283ZM14.7462 14.9662C15.64 14.9662 16.321 15.6491 16.321 16.5454C16.321 17.4418 15.64 18.1247 14.7462 18.1247C13.8524 18.1247 13.1714 17.4418 13.1714 16.5454C13.1714 15.6918 13.8524 14.9662 14.7462 14.9662Z","fill":"currentColor"}})])
          )
        }
      }
    